export const getAlentejoCentralData = () => ({
  name: "Alentejo Central",
  country: "Portugal",
  region: "Alentejo",
  description: "Alentejo Central est le cœur viticole de l'Alentejo, produisant des vins rouges et blancs de qualité avec des cépages traditionnels et internationaux.",
  type: "subregion",
  mapAreas: [
    { region: "Alentejo Central", x: 42, y: 35, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "600,000 hl",
    wineries: "100+ quintas",
    villages: "12 villages",
    exportPercentage: "50%"
  },
  characteristics: {
    climate: "Climat méditerranéen continental, étés chauds et secs",
    soil: "Sols argilo-calcaires, granitiques, schisteux",
    viticulture: "Viticulture moderne, irrigation contrôlée"
  },
  wineStyles: {
    red: "Rouges fruités et équilibrés, assemblages traditionnels et modernes",
    white: "Blancs secs et aromatiques, principalement d'Antão Vaz"
  },
  history: "Alentejo Central produit des vins depuis l'époque romaine. La région a modernisé sa viticulture dans les années 1990.",
  foodPairing: "Cuisine portugaise, viandes rouges, fromages affinés, charcuteries",
  grapeVarieties: [
    {
      name: "Aragonez",
      percentage: "30%",
      description: "Cépage principal de l'Alentejo, produisant des vins fruités et équilibrés",
      characteristics: "Fruité, équilibré, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Trincadeira",
      percentage: "25%",
      description: "Cépage autochtone, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, tanins fins, notes de violette",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Alicante Bouschet",
      percentage: "20%",
      description: "Cépage teinturier, apportant couleur et structure",
      characteristics: "Coloré, structuré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Antão Vaz",
      percentage: "15%",
      description: "Cépage blanc principal, produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, notes d'agrumes et de fleurs",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Syrah",
      percentage: "10%",
      description: "Cépage international, apportant puissance et épices",
      characteristics: "Puissant, épicé, notes de poivre noir",
      wineStyles: "Sec, plein-corps, épicé"
    }
  ]
}); 